import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";
import {makeGarrisonItems} from "../helpers/initial-info-items.jsx";

export default function Garrison({ title, data }) {
    const garrison = makeGarrisonItems(data);

    return (
        <>
            <InfoGrid title={title} items={garrison} columns={3} />
        </>
    )
}